import React, {useState} from 'react';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import {TabBox} from '../../../shared/elements/tab/TabBox';
import CustomerInfoTabView from './customerTabs/CustomerInfoTabView.jsx';
import CustomerUploadTabView from '../invoices/CustomerUploadTabView.jsx';
import CustomerDownloadTabView from '../invoices/CustomerDownloadTabView.jsx';
import ExtraWorkEntriesTabView from '../extraWork/ExtraWorkEntriesTabView.js';

function CustomerInfo({t, selectedCustomer, setEditCustomerModal}) {
    if (!selectedCustomer) return <p>{t('customer.NoCustomerChosen')}</p>;
    const [activeTab, setActiveTab] = useState('info');

    return (
        <Wrapper>
            <TabBox>
                <TabBox.Option active={activeTab === 'info'} onClick={() => setActiveTab('info')}>
                    {t('warehousing.tabs.InformatieTab')}
                </TabBox.Option>
                <TabBox.Option active={activeTab === 'extraWork'} onClick={() => setActiveTab('extraWork')}>
                    {t('warehousing.tabs.ExtraWorkTab')}
                </TabBox.Option>
                <TabBox.Option active={activeTab === 'upload'} onClick={() => setActiveTab('upload')}>
                    {t('warehousing.tabs.UploadTab')}
                </TabBox.Option>
                <TabBox.Option active={activeTab === 'download'} onClick={() => setActiveTab('download')}>
                    {t('warehousing.tabs.DownloadTab')}
                </TabBox.Option>
            </TabBox>
            {activeTab === 'info' && (
                <CustomerInfoTabView selectedCustomer={selectedCustomer} setEditCustomerModal={setEditCustomerModal} />
            )}
            {activeTab === 'extraWork' && <ExtraWorkEntriesTabView selectedCustomer={selectedCustomer} />}
            {activeTab === 'upload' && <CustomerUploadTabView selectedCustomer={selectedCustomer} />}
            {activeTab === 'download' && <CustomerDownloadTabView selectedCustomer={selectedCustomer} />}
        </Wrapper>
    );
}

const Wrapper = styled.div`
    width: 100%;
    ${TabBox} {
        margin-bottom: var(--space-lg);
    }
    ${TabBox.OptionContainer} {
        padding: 6px 14px;
        font-weight: 600;
    }
`;
export default withTranslation()(CustomerInfo);
